import { Component, Input } from '@angular/core';

@Component({
  selector: 'icc-calculation-indicator',
  templateUrl: './calculation-indicator.component.html',
  styleUrls: ['./calculation-indicator.component.scss'],
  exportAs: 'iccCalculationIndicator',
})
export class CalculationIndicatorComponent {

  private _animation = false;

  @Input()
  get animation(): boolean {
      return this._animation;
  }
  set animation(action: boolean) {
      this._animation = action;
  }

}
